import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePerfilOpcionesView.
 * @extends JetView
 */
export default class tablePerfilOpcionesView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service

        return {
            css: 'my_permissions', // CSS class for styling
            cols: [
                {
                    rows: [
                        {
                            type: 'space', // Space type for layout
                            css: 'my_permissions', // CSS class for styling
                            rows: [
                                {
                                    cols: [
                                        {
                                            view: 'combo', // Combo box for filtering permissions
                                            id: 'FilterFather', // Unique ID for the combo
                                            label: _('Buscar Permiso'), // Label for the combo
                                            labelPosition: 'top', // Position of the label
                                            css: 'my_filter', // CSS class for styling
                                            options: [], // Options for the combo
                                            on: {
                                                onChange(newVal) {
                                                    // Event handler for change
                                                    $$('dataview').filter(
                                                        // Filtering dataview based on input
                                                        function (obj) {
                                                            return obj.id.toString().indexOf(newVal) != -1;
                                                        },
                                                    );
                                                },
                                            },
                                        },
                                    ],
                                },
                                {
                                    view: 'grouplist', // Group list for displaying permissions
                                    id: 'dataview', // Unique ID for the dataview
                                    xCount: 1, // Number of columns in the group list
                                    onClick: {
                                        metadata_config_check: function (e, id) {
                                            // Click event handler for items
                                            var item = this.getItem(id); // Get the clicked item
                                            item.markCheckbox = item.markCheckbox ? 0 : 1; // Toggle checkbox state
                                            this.updateItem(id, item); // Update the item in the list
                                            var arrayAgregados = []; // Array for added permissions
                                            var arrayEliminados = []; // Array for removed permissions
                                            if (item.markCheckbox == 1) {
                                                arrayAgregados.push(item.id); // Add to added array
                                            } else {
                                                if (item.markCheckbox == 0) {
                                                    arrayEliminados.push(item.id); // Add to removed array
                                                }
                                            }
                                            var roleId = $$('TypeUser').getValue(); // Get selected role ID
                                            var userId = $$('Username').getValue(); // Get selected user ID
                                            if (roleId == 'CUSTOM' && (userId == 0 || userId == '')) {
                                                webix.confirm({
                                                    // Confirmation dialog for user selection
                                                    type: 'confirm-warning',
                                                    text: _('Error!') + '<br/>' + _('Debe de seleccionar un usuario.'),
                                                    ok: _('OK'),
                                                    cancel: _('Salir'),
                                                    callback: function (action) {
                                                        if (action === true) {
                                                        }
                                                    },
                                                });
                                                return; // Exit if no user is selected
                                            }
                                            webix
                                                .ajax() // AJAX request to save permissions
                                                .headers({
                                                    'Content-type': 'application/json', // Set content type
                                                })
                                                .post(
                                                    devConfig.geturlApi() + // API URL for saving permissions
                                                        'UserManagement/SavePermissionsForRole',
                                                    '{"roleId":"' +
                                                        roleId +
                                                        '","userId":"' +
                                                        userId +
                                                        '","permAdd":"' +
                                                        arrayAgregados +
                                                        '","permDelete":"' +
                                                        arrayEliminados +
                                                        '"}',
                                                    {
                                                        error: function (text, data, XmlHttpRequest) {
                                                            // Error handler
                                                            webix.message(_('Error! ')); // Show error message
                                                        },
                                                        success: function (text, data, XmlHttpRequest) {}, // Success handler
                                                    },
                                                );
                                        },
                                    },
                                    template: function (obj) {
                                        // Template for rendering items
                                        return (
                                            `
                      <span class='metadata_config_check webix_icon wxi-checkbox-` +
                                            (obj.markCheckbox ? 'marked' : 'blank') +
                                            ` +square-o'></span>
                      <div style="width: 100%;height: 100%;">
                        <p class="my-text-list">` +
                                            obj.value +
                                            `</p>
                      </div>
                      `
                                        );
                                    },
                                },
                            ],
                        },
                    ],
                },
            ],
        };
    }
}

// FILE DOCUMENTED
